import { render } from "./WorkDetailContent.vue?vue&type=template&id=33296fc7&scoped=true"
import script from "./WorkDetailContent.vue?vue&type=script&lang=js"
export * from "./WorkDetailContent.vue?vue&type=script&lang=js"

import "./WorkDetailContent.vue?vue&type=style&index=0&id=33296fc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33296fc7"]])

export default __exports__